module.exports = __webpack_public_path__ + "img/chapterwise.4d1fc3c9.png";